module.exports = __webpack_public_path__ + "static/Hyperproof-27b37398b041fdad0a6617837b582245.jpg";